import React from 'react';
import { RouterPaths } from './router.tsx';
import { OfflineBanner } from './components/OfflineBanner/OfflineBanner';
import { usePendingVoteReplay } from './hooks/usePendingVoteReplay';

export const App: React.FC = () => {
  // Replay a vote taken before sign-in, once the user is authenticated.
  usePendingVoteReplay();

  return (
    <>
      <OfflineBanner />
      <RouterPaths />
    </>
  );
};

export default App;
